import {autoImplement} from '@/util';
import moment, {Moment} from 'moment';

export interface ApiNVE {
  Datum: string;
  NVE: string;
  Chargennr: number;
  Restmenge: number;
  Anerkennungsnr?: string;
  ChargenNrLief?: string;
  MHD?: string;
  Niederlassung?: number;
  Lagerhalle?: number;
  Lagerfach?: number;
}

export interface NVESearch {
  Chargennr: number;
  Datum: string;
  Niederlassung: number;
  Lagerhalle: number;
  Lagerfach: number;
  NVE: string;
  Restmenge: number;
  ArtikelNr: string;
}

export interface NVEInterface extends ApiNVE {
  MHDParsed?: Moment,
}

export default class NVE extends autoImplement<NVEInterface>() {
  Niederlassung?: number;
  Lagerhalle?: number;
  Lagerfach?: number;
  static fromApi(apiNVE: ApiNVE): NVE {
    const {
      MHD,
      ...data
    } = apiNVE;
    return new NVE({
      ...data,
      MHD,
      MHDParsed: MHD ? moment(MHD) : undefined,
    });
  }
}
